var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [!_vm.accessToken ? [_c('lecture-auth')] : [_c('lecture-view')]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }